export default ({ subject }) => subject && subject.permissions.can_close && !subject.board_closed;
